import { render, staticRenderFns } from "./osa-assessment-report.vue?vue&type=template&id=28e522dc&scoped=true"
import script from "./osa-assessment-report.vue?vue&type=script&lang=js"
export * from "./osa-assessment-report.vue?vue&type=script&lang=js"
import style0 from "./osa-assessment-report.vue?vue&type=style&index=0&id=28e522dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e522dc",
  null
  
)

export default component.exports